import React from 'react';
import { Chip } from '@mui/material';
import { WbSunnyRounded, NightsStayRounded } from '@mui/icons-material';

export const userType = [
    { label: 'Admin', value: 'A' },
    { label: 'Distributor', value: 'D' },
    { label: 'Customer', value: 'C' },
]

export const validInvalidOptions = [
    { label: 'Valid', value: 'V' },
    { label: 'Invalid', value: 'I' },
]

export const yesNoOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' },
]

export const activeInactiveOptions = [
    { label: 'Active', value: 'A' },
    { label: 'Inactive', value: 'I' },
]

export const genderOptions = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
]

export const VENDOR_TYPE = {
    SUN: 'S',
    MOON: 'M',
}

export const vendorTypeOptions = [
    { label: 'Healthy', value: VENDOR_TYPE.SUN, icon: WbSunnyRounded },
    { label: 'Balance', value: VENDOR_TYPE.MOON, icon: NightsStayRounded },
]

export const getVendorTypeLabel = (value) => {
    return vendorTypeOptions.find(o => o.value === value)?.label || value || '-'
}

export const getVendorTypeColor = (value) => {
    switch (value) {
        case VENDOR_TYPE.SUN: return { bg: 'warning', button: 'primary' };
        case VENDOR_TYPE.MOON: return { bg: 'info', button: 'secondary' };
        default: return { bg: 'default', button: 'default' };
    }
}

// Bank Type
export const bankTypeOptions = [
    { value: 'Savings', label: 'Savings' },
    { value: 'Current', label: 'Current' },
    { value: 'Fixed Deposit', label: 'Fixed Deposit' },
]


export const paymentMethod = [
    { value: 'Online', label: 'Online' },
    { value: 'COD', label: 'Cash on Delivery' }
]

export const paymentGateways = [
    { value: 'Khalti', label: 'Khalti', icon: "khalti.png" },
    { value: 'Esewa', label: 'Esewa', icon: "esewa.png" },
]

export const KYC_STATUS = {
    S: 'Submitted',
    P: 'Pending',
    A: 'Approved',
    R: 'Rejected',
}

export const kycStatusColor = (status) => {
    switch (status) {
        case 'S': return { bg: 'info', label: 'Submitted' };
        case 'P': return { bg: 'warning', label: 'Pending' };
        case 'A': return { bg: 'success', label: 'Approved' };
        case 'R': return { bg: 'error', label: 'Rejected' };
        default: return { bg: 'default', label: status || 'Unknown' };
    }
}

export const shippingMethod = [
    { value: 'Delivery', label: 'Delivery' },
    { value: 'Pickup', label: 'Pickup' }
]

// Pricing (MRP is VAT-inclusive; VAT is extracted, not added)
export const VAT_RATE = 13;
export const SHIPPING_CHARGE = 120;

export const calcVatFromInclusiveAmount = (amount) =>
    (Number(amount || 0) * VAT_RATE) / (100 + VAT_RATE);

export const orderStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case 'placed': return { bg: 'info', label: 'Placed' };
        case 'confirmed': return { bg: 'primary', label: 'Confirmed' };
        case 'processing': return { bg: 'warning', label: 'Processing' };
        case 'shipped': return { bg: 'warning', label: 'Shipped' };
        case 'out for delivery': return { bg: 'info', label: 'Out for Delivery' };
        case 'delivered': return { bg: 'success', label: 'Delivered' };
        case 'cancelled': return { bg: 'error', label: 'Cancelled' };
        default: return { bg: 'default', label: status || 'Unknown' };
    }
};

export const paymentStatusColor = (status) => {
    switch (status?.toUpperCase()) {
        case 'P': return { bg: 'warning', label: 'Pending' };
        case 'VP': return { bg: 'warning', label: 'Verified Pending' };
        case 'S': return { bg: 'success', label: 'Paid' };
        case 'F': return { bg: 'error', label: 'Failed' };
        case 'C': return { bg: 'info', label: 'Cancelled' };
        default: return { bg: 'default', label: status || 'Unknown' };
    }
};

export const PROD_ECOM_TYPE = {
    ESSENTIAL: 'E',
    LIFESTYLE: 'L',
}

export const prodEcomTypeOptions = [
    { label: 'Essential', value: PROD_ECOM_TYPE.ESSENTIAL },
    { label: 'Lifestyle', value: PROD_ECOM_TYPE.LIFESTYLE },
]

export const getProdEcomTypeLabel = (value) => {
    return prodEcomTypeOptions.find(o => o.value === value)?.label || value || '-'
}

export const EligibilityChip = ({ value }) => React.createElement(
    Chip,
    {
        label: value === 'Y' ? 'Yes' : value === 'N' ? 'No' : (value || '—'),
        color: value === 'Y' ? 'success' : value === 'N' ? 'error' : 'default',
        size: 'small',
    }
);